import React from 'react';
export default function EmptyTeamScores({ blockName, isHome}){
  const homeOrAwayClass = isHome ? 'home' : 'away';
  const baseBlockName = `${ blockName }__list-item`;
  const teamBlockName = `${ baseBlockName } ${ baseBlockName }--${ homeOrAwayClass }`;
  const shirtBlockName = `${ blockName }__shirt-placeholder`;
  const teamNameBlockName = `${ blockName}__team-placeholder`;
  return (
    <div className={ teamBlockName }>
      <div className={ shirtBlockName }></div>
      <div className={ teamNameBlockName }></div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/emptyTeamScores.js